var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transaction-history"},[_c('div',{staticClass:"title"},[_vm._v("Transaction History (14 days)")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"graph"},[_c('canvas',{ref:"canvas"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }